<template>
    <div class="base-panel">
        <div class="base-panel-head space-between">
            <div>每千瓦实时功率&归一化辐照强度</div>
        </div>
        <div class="base-panel-body">
            <basic-echarts ref="powerRadiation" :height="'100%'"></basic-echarts>
        </div>
    </div>
</template>

<script>
    import BasicEcharts from "@/components/Echarts/BasicEcharts";
    export default {
        name: "powerAndRadiation",
        components:{
            BasicEcharts
        },
        data(){
            return {
                groupId: 0,
                data:{
                    XStationName:[1,2,3,4,5],
                    YeachKwPower:[20,23,59,78,90],
                    YnormalizationRadiation:[3,5,7,8,9]
                }
            }
        },
        mounted() {
            this.groupId = this.$Utils.getUserStorage().groupId;
            this.loadChart();
        },
        methods:{
            async loadChart(){
                let result = await this.$http.get(this.$baseURL.powerAndRadiation(this.groupId));
                console.log(result)

                this.data.XStationName = [];
                this.data.YeachKwPower = [];
                this.data.YnormalizationRadiation = [];
                result.forEach(item => {
                    this.data.XStationName.push(item.powerStationName);
                    this.data.YeachKwPower.push(Number((item.eachKwPower).toFixed(2)));
                    this.data.YnormalizationRadiation.push(Number(item.normalizationRadiation.toFixed(2)));
                });


                let option = {
                    tooltip : {
                        trigger: 'axis',
                        formatter: function (data) {
                            let html = '';
                            data.forEach((item, index ) => {
                                if(index === 0){
                                    html += item.axisValueLabel;
                                }
                                html += '<br>' + item.marker + item.seriesName + ': ' + item.value + (item.componentIndex === 0 ? 'kW/kWp' : '');

                            });
                            //console.log(data)
                            return html;
                        }

                    },
                    legend: {
                        top: '5%',
                        selectedMode:false,
                        data:[{
                            name:"每千瓦实时功率",
                            textStyle:{
                                color:"#FFFFFF"
                            }
                        },{
                            name:"归一化辐照强度",
                            textStyle:{
                                color:"#FFFFFF"
                            }
                        }]
                    },
                    toolbox: {
                        show : false,
                        feature : {
                            mark : {show: true},
                            dataView : {show: true, readOnly: false},
                            magicType : {show: true, type: ['line', 'bar']},
                            restore : {show: true},
                            saveAsImage : {show: true}
                        }
                    },
                    calculable : false,
                    xAxis : [
                        {
                            type : 'category',
                            data : this.data.XStationName,
                            axisLabel : {
                                show:true,
                                textStyle:{
                                    color:"#FFFFFF"
                                }
                            },
                            splitArea: {
                                show: false
                            }
                        }
                    ],
                    grid:{
                        left: '7%',
                        right: '7%',
                        top: '20%',
                        bottom: '10%'
                    },
                    yAxis : [
                        {
                            type : 'value',
                            name:"kW/kWp",
                            nameTextStyle:{
                                color:"#FFFFFF"
                            },
                            axisLabel : {
                                show:true,
                                interval: 'auto',    // {number}
                                textStyle:{
                                    color:"#FFFFFF"
                                }
                            },
                            splitLine : {
                                show: true,
                                color: ['#ccc'],
                                width: 1,
                                lineStyle: {
                                    type: 'dashed'
                                }
                            },
                            splitArea: {
                                show: false
                            }
                        },
                        {
                            type: 'value',
                            name: "",
                            nameTextStyle:{
                                color:"#FFFFFF"
                            },
                            axisLabel : {
                                show:true,
                                interval: 'auto',    // {number}
                                textStyle:{
                                    color:"#FFFFFF"
                                }
                            },
                            splitLine : {
                                show: true,
                                color: ['#ccc'],
                                width: 1,
                                lineStyle: {
                                    type: 'dashed'
                                }
                            },
                            splitArea: {
                                show: false
                            }
                        }
                    ],
                    series : [
                        {
                            name:'每千瓦实时功率',
                            type:'bar',
                            barMaxWidth:30,
                            itemStyle: {
                                normal: {
                                    borderRadius: 5,
                                    label : {
                                        show : true,
                                        position: 'top'
                                    }
                                }
                            },
                            data: this.data.YeachKwPower
                        },
                        {
                            name:'归一化辐照强度',
                            type:'bar',
                            barMaxWidth:30,
                            yAxisIndex: 1,
                            itemStyle: {
                                normal: {
                                    borderRadius: 5,
                                    label : {
                                        show : true,
                                        position: 'top'
                                    }
                                }
                            },
                            data: this.data.YnormalizationRadiation
                        }
                    ]
                };
                this.$refs.powerRadiation.refresh(option);
            }
        }
    }
</script>

<style scoped>

</style>
